export var log = function (collectionName, type, data, id) {
    console.groupCollapsed('Mock Analytics:', collectionName, type);
    id && console.log('ID', id);
    console.log('Data', data);
    console.groupEnd();
};
